import { Component, Inject, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import ScrapAgentService from '@/service/scrap-agent.service';
import { AppInfo } from '@/shared/model/scrap-agent.model';
import WebsocketService from '@/service/websocket.service';

@Component({
  components: { DsModal },
})
export default class FacebookAuthComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;
  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;
  @Inject('websocketService')
  private websocketService: () => WebsocketService;

  showModal = this.open;
  appInfo: AppInfo | null = null;
  baseUrl = window.location.origin;
  authState = '';
  messageProcessed = false;
  showInputName = false;
  accountName: null;

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.accountName = null;
    if (value) {
      this.authState = this.generateWindowId();
    } else {
      this.authState = '';
    }
    // window.removeEventListener('message', this.receiveMessage);
    // window.addEventListener('message', this.receiveMessage, false);
    if (value) {
      this.scrapAgentService()
        .getAppInfo('FACEBOOK')
        .then((result: any) => {
          if (result && result.body && result.body.length > 0) {
            this.appInfo = {
              appId: result.body[0].appId,
              redirectUrl: result.body[0].redirectUrl,
              clientId: result.body[0].clientId,
              scope: result.body[0].scope,
              clientSecret: result.body[0].clientSecret,
            };
            console.log('Fetched Facebook appInfo:', this.appInfo);
          }
        })
        .catch(error => {
          console.error('Failed to fetch Facebook app info:', error);
        });
    }
  }

  handleCloseModal() {
    this.$emit('modal:close');
  }

  // Generate a unique id for this window instance.
  generateWindowId(): string {
    return 'id_' + Math.random().toString(36).substr(2, 9);
  }

  // Build Facebook authUrl
  get authUrl(): string {
    if (!this.appInfo) {
      return '';
    }

    // Use the pathname from appInfo.redirectUrl and the current domain
    const redirectPath = new URL(this.appInfo.redirectUrl).pathname;
    const finalRedirectUri = encodeURIComponent(`${this.baseUrl}${redirectPath}`);
    const state = this.authState;

    // Facebook OAuth URL format
    return `https://www.facebook.com/v22.0/dialog/oauth?client_id=${
      this.appInfo.clientId
    }&redirect_uri=${finalRedirectUri}&scope=${encodeURIComponent(this.appInfo.scope)}&response_type=code&state=${state}`;
  }

  openFacebookPopup() {
    if (!this.appInfo) {
      console.error('Facebook app info is not loaded yet.');
      return;
    }

    console.log(`Opening Facebook auth popup... ${this.authUrl}`);

    const width = 600,
      height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const popup = window.open(this.authUrl, 'FacebookAuth', `width=${width},height=${height},top=${top},left=${left}`);
    try {
      // Subscribe to the token channel only once
      const subscription = this.websocketService().subscribeTokenAuth(this.authState, {
        next: authCode => {
          console.log('Received authCode from WebSocket:', authCode);
          this.handleAccountConnect(authCode).then(r => {});
          subscription.unsubscribe();
        },
        error: err => {
          console.error('Error receiving authCode:', err);
        },
      });
    } catch (error) {
      console.error('Error subscribing to authCode channel:', error);
    }
  }

  receiveMessage(event: MessageEvent) {
    if (this.messageProcessed) {
      return;
    }

    // Verify that the message payload contains the expected state and authorization_code
    if (event.data && event.data.authorization_code && event.data.state === this.authState) {
      this.messageProcessed = true;
      const authCode = event.data.authorization_code;
      console.log('Received Facebook authorization code:', authCode);
    } else {
      this.messageProcessed = false;
      console.warn('Ignoring unexpected message payload:', event.data);
    }
  }

  async handleAccountConnect(authorizationCode: string) {
    const payload = {
      accountName: this.accountName || null,
      authorizationCode: authorizationCode,
      appId: this.appInfo?.appId,
      avatar: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/facebook.png',
      chanelName: 'FACEBOOK',
      clientId: this.appInfo?.clientId,
      clientSecret: this.appInfo?.clientSecret,
      redirectUrl: `${this.baseUrl}/api/public/goAuth`,
      scope: this.appInfo?.scope,
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
    };
    console.log(payload, 'payload');
    try {
      const result = await this.scrapAgentService().addUserAccount(payload);
      const responseBody = result?.data?.body?.body?.body;
      // if (!responseBody?.isSuccess) {
      //   alert('Authorization failed. Please try again.');
      //   return;
      // }
      if (result) {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messAuSuccess')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleAuSuccess')}`,
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
      }
      this.$emit('modal:close', responseBody.accountId);
    } catch (error) {
      console.log(error, 'error');
      const errorDetail = error?.response?.data?.detail;
      // const jsonArrayStr = errorDetail.match(/\[\{.*\}\]/s);
      // const parsedDetail = JSON.parse(jsonArrayStr);
      // console.log(parsedDetail, 'parsedDetail');
      // const status = parsedDetail?.statusCodeValue;
      // const message = parsedDetail?.body?.message;
      // const bodyMessage = parsedDetail?.body?.body;
      this.showInputName = !!errorDetail?.includes('please enter you account name');
      if (this.showInputName) {
        this.$bvToast.toast('Cannot get user info, please enter you account name', {
          toaster: 'b-toaster-bottom-right',
          title: 'Create account',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      } else {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messFail')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleAuFail')}`,
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      }
    } finally {
      this.messageProcessed = false;
    }
  }
}
